import templateUrl from "emun.auth/users/user-editor.htm";
import controller from "emun.auth/users/user-editor.controller";

export default {
  bindings: {
    user: "<?",
    userId: "@",
    title: "@",
    subTitle: "@",
    onSaved: "&",
    onCancel: "&"
  },
  require: {
    manager: "^userManager"
  },
  controller,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  }
};
